import { render, staticRenderFns } from "./ViewAllInterviewers.vue?vue&type=template&id=5579c915&scoped=true"
import script from "./ViewAllInterviewers.vue?vue&type=script&lang=ts"
export * from "./ViewAllInterviewers.vue?vue&type=script&lang=ts"
import style0 from "./ViewAllInterviewers.vue?vue&type=style&index=0&id=5579c915&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5579c915",
  null
  
)

export default component.exports